import { NxButtonModule } from "@allianz/ng-aquila/button";
import { CommonModule } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject
} from "@angular/core";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { TranslateModule } from "@ngx-translate/core";
import { Subject, tap } from "rxjs";
import { ProcessStore } from "../../../shared/store/process.store";

@Component({
  selector: "app-navigation-buttons",
  imports: [FontAwesomeModule, TranslateModule, NxButtonModule, CommonModule],
  templateUrl: "./navigation-buttons.component.html",
  styleUrl: "./navigation-buttons.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationButtonsComponent {
  // services
  private readonly processStore = inject(ProcessStore);

  // state
  currentStep = computed(() => this.processStore.currentStep());
  hasNextStep = computed(() => this.processStore.hasNextStep());
  hasPreviousStep = computed(() => this.processStore.hasPreviousStep());
  currentStepValidity = computed(() => this.processStore.currentStepValidity());

  // events
  handleNextStep$ = new Subject<void>();
  handlePreviousStep$ = new Subject<void>();

  constructor() {
    this.handleNextStep$
      .pipe(
        tap(() => {
          this.processStore.nextStep$.next();
        }),
      )
      .subscribe();

    this.handlePreviousStep$
      .pipe(
        tap(() => {
          this.processStore.previousStep$.next();
        }),
      )
      .subscribe();
  }
}
